import React from 'react';


const FrontpageCaps = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='Screen__Start__Background'>
                <img src="/img/games/runtogoal/background-1.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
            </div>

            <div className="caps-intro">
                
                {/* Contenedor de Logos y Título */}
                <div className="caps-intro__logo-container">
                    <div className='d-flex align-items-center justify-content-center'>
                        <img src="/img/page/xolos-five-black.png" className="caps-intro__logo" alt="Patrocinador Central" style={{ backgroundColor: '#fff', padding: '0', borderRadius: '10px' }} />
                    </div>
                    
                    <p className="caps-intro__text text-uppercase fw-bold mt-4" style={{ textShadow: '-4px 0 #1e246a, 0 4px #1e246a, 4px 0 #1e246a, 0 -4px #1e246a' }}>Presentan</p>
                    <p className="caps-intro__title text-uppercase fw-black" style={{ textShadow: '-4px 0 #1e246a, 0 4px #1e246a, 4px 0 #1e246a, 0 -4px #1e246a' }}>Encuentra el balón</p>
                </div>

                {/* La gorra animada que flota en el centro */}
                <div className='d-flex align-items-center justify-content-center'>
                    <img src="/img/games/caps/cap.png" className="caps-intro__hero" alt="Gorra Misteriosa" />
                </div>

                {/* Footer de Créditos */}
                <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px', color: '#000' }}>Hecho con ♥ por Five Digital Minds | 2026</p>
            </div>
        </>
    );
};

export { FrontpageCaps };